import { combineReducers, configureStore } from "@reduxjs/toolkit";
import LayoutSlice from "./Reducers/LayoutSlice";
import BookmarkHeaderSlice from "./Reducers/BookmarkHeaderSlice";
import ThemeCustomizerSlice from "./Reducers/ThemeCustomizerSlice";
import auditReducer from "./Reducers/Expense/auditSlice";
import expenseReducer from "./Reducers/Expense/expenseSlice";
import employeeSlice from "./Reducers/Expense/EmployeeList_Slice";
import brandCampaignSlice from "./Reducers/BrandCampaign/BrandCampaignSlice";
import brandCampaignStepsSlice from "./Reducers/BrandCampaign/BrandCampaignStepSlice";
import brandCampaignStepSelectionSlice from "./Reducers/BrandCampaign/BrandCampaignStepSelectionSlice";
import employeeModuleSlice from "./Reducers/Employee/EmployeeListModule"
import attendanceModuleSlice from "./Reducers/Employee/AttendanceListModule"
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "expense",
    "audit",
    "employee",
    "brandCampaign",
    "brandCampaignSteps",
    "brandCampaignStepSelectionSlice",
    "employeeModule",
    "attendanceModule"
  ], // 👈 only persist expense slice (you can add more)
};

const rootReducer = combineReducers({
  layout: LayoutSlice,
  bookmarkHeader: BookmarkHeaderSlice,
  themeCustomizer: ThemeCustomizerSlice,
  audit: auditReducer,
  expense: expenseReducer,
  employee: employeeSlice,
  brandCampaign: brandCampaignSlice, // 👈 added
  brandCampaignSteps: brandCampaignStepsSlice, // 👈 added
  brandCampaignStepSelection: brandCampaignStepSelectionSlice,
  employeeModule:employeeModuleSlice,
  attendanceModule:attendanceModuleSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

//*************** Old code *******************
// const Store = configureStore({
//   reducer: {
//     layout: LayoutSlice,
//     bookmarkHeader: BookmarkHeaderSlice,
//     themeCustomizer: ThemeCustomizerSlice,
//     audit:auditReducer,
//     expense:expenseReducer,
//     employee:employeeSlice
//   },
// });

export const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // redux-persist needs this off
    }),
});

// export default Store;
export const persistor = persistStore(Store);
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
